module.exports = __webpack_public_path__ + "static/media/4_v2-01-01.08150b98.png";